import { render, staticRenderFns } from "./FullViewRoot.vue?vue&type=template&id=25f999ec"
import script from "./FullViewRoot.vue?vue&type=script&lang=ts&setup=true"
export * from "./FullViewRoot.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./FullViewRoot.vue?vue&type=style&index=0&id=25f999ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports